/**
 * Product Title Variants
 * Updates the product title suffix when variant selection changes.
 * Subscribes to the variantChange pub/sub event and updates the
 * ProductTitleVariants-{sectionId} element with the new variant options.
 */
document.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
    const titleVariantsElement = document.getElementById(`ProductTitleVariants-${sectionId}`);

    if (titleVariantsElement && variant?.options) {
      const suffix = variant.options.join(' ');
      titleVariantsElement.textContent = suffix === 'Default Title' ? '' : suffix;
    }
  });
});
